import React from "react";
import "./NavBar.css";
import avatar from "../../img/assets/user.jpg";
import { NavLink } from "react-router-dom";

function NavBar() {
  const pesent_date = new Date();

  return (
    <div className="Navbar">
      <nav className="nav">
        <div className="profile">
          <img src={avatar} alt="" />
        </div>
        <ul className="nav-items">
          <li className="nav-item">
            <NavLink to="/" exact activeClassName="active">
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/about" exact activeClassName="active">
              About
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/portfolios" exact activeClassName="active">
              Portfolio
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/blogs" exact activeClassName="active">
              Blogs
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/contact" exact activeClassName="active">
              Contact
            </NavLink>
          </li>
        </ul>
        <footer className="footer">
          <p>&#169; {pesent_date.getFullYear()} Lorem Ipsum</p>
        </footer>
      </nav>
    </div>
  );
}

export default NavBar;
